import { notificationService } from '../services/notificationService';

export const NOTIFICATION_READ_EVENT = 'cybershield:notification-read';

export interface NotificationReadEventDetail {
  id: string | number;
  previousStatus?: string | null;
  nextStatus: 'read';
}

export const isUnreadNotificationStatus = (status?: string | null): boolean => {
  const normalized = (status || '').trim().toLowerCase();
  return normalized !== 'read' && normalized !== 'dismissed';
};

export const dispatchNotificationRead = (
  id: string | number,
  previousStatus?: string | null,
  nextStatus: 'read' = 'read'
) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<NotificationReadEventDetail>(NOTIFICATION_READ_EVENT, {
    detail: { id, previousStatus, nextStatus },
  }));
};

export const markNotificationReadIfUnread = async (
  id: string | number,
  previousStatus?: string | null
): Promise<boolean> => {
  if (!isUnreadNotificationStatus(previousStatus)) return false;
  await notificationService.markNotificationRead(Number(id));
  dispatchNotificationRead(id, previousStatus, 'read');
  return true;
};
